import React, { useState } from 'react';
import './Payment.css';
import '../../components/Button/Button.css';

const Payment = ({ orderData, onBack }) => {
  // Parse URL parameters if orderData is not provided
  const pathParts = window.location.pathname.split('/');
  const hashrate = orderData?.hashrate || parseFloat(pathParts[3]) || 50;
  const contractPeriod = orderData?.contractPeriod || parseInt(pathParts[4]) || 12;
  const prepaidMonths = orderData?.prepaidMonths || parseInt(pathParts[5]) || 6;
  const paymentAmount = orderData?.paymentAmount || parseFloat(pathParts[6]) || 383.16;

  const [selectedMethod, setSelectedMethod] = useState(null);
  const [selectedCoin, setSelectedCoin] = useState('');
  const [selectedNetwork, setSelectedNetwork] = useState('');
  const [address, setAddress] = useState('');
  const [step, setStep] = useState(1);
  const [mpesaPhone, setMpesaPhone] = useState('');
  const [mpesaPending, setMpesaPending] = useState(false);
  const [cardNumber, setCardNumber] = useState('');
  const [cardExpiry, setCardExpiry] = useState('');
  const [cardCvv, setCardCvv] = useState('');
  const [bankAmount, setBankAmount] = useState('');
  const [bankReference, setBankReference] = useState('');

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-US', { 
      style: 'currency', 
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value);
  };

  const selectMethod = (method) => {
    setSelectedMethod(method);
    setStep(2);
  };

  const onCoinChange = (e) => {
    const coin = e.target.value;
    setSelectedCoin(coin);
    setSelectedNetwork('');
    setAddress('');
  };

  const onNetworkChange = (e) => {
    setSelectedNetwork(e.target.value);
  };

  const generateAddress = () => {
    const addresses = {
      btc: 'bc1qxy2kgdygjrsqtzq2n0yrf2493p83kkfjhx0wlh',
      eth: '0x742d35Cc6634C0532925a3b844Bc9e7595f0b9e',
      usdt: '0x742d35Cc6634C0532925a3b844Bc9e7595f0b9e',
      usdc: '0x742d35Cc6634C0532925a3b844Bc9e7595f0b9e',
      bnb: 'bnb1xy2kgdygjrsqtzq2n0yrf2493p83kkfjhx0wlh',
      sol: '7xKXtg2CW87d97TXJSDpbD5jBkheTqA83TZRuJosgAsU'
    };
    setAddress(addresses[selectedCoin] || '');
    setStep(3);
  };

  const copyAddress = () => {
    navigator.clipboard.writeText(address);
    alert('Address copied to clipboard!');
  };

  const setMpesaAmountValue = (amount) => {
    // M-Pesa amount is fixed to payment amount
  };

  const submitMpesa = () => {
    setMpesaPending(true);
  };

  const cancelMpesa = () => {
    setMpesaPending(false);
  };

  const confirmMpesa = () => {
    setStep(3);
    alert('M-Pesa payment confirmed!');
  };

  const formatCardNumber = (e) => {
    let value = e.target.value.replace(/\s/g, '');
    let formatted = value.match(/.{1,4}/g)?.join(' ') || value;
    setCardNumber(formatted);
  };

  const formatExpiry = (e) => {
    let value = e.target.value.replace(/\D/g, '');
    if (value.length >= 2) {
      value = value.slice(0, 2) + '/' + value.slice(2, 4);
    }
    setCardExpiry(value);
  };

  const submitCard = () => {
    setStep(3);
    alert('Card payment submitted!');
  };

  const submitBank = () => {
    setStep(3);
    alert('Bank transfer submitted!');
  };

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      const url = `/order/contract-review/${hashrate}/${contractPeriod}/${prepaidMonths}/${paymentAmount}`;
      window.history.pushState({ page: 'order' }, '', url);
      window.location.reload();
    }
  };

  return (
    <div className="holder payment-container">
      <div>
        <div className="payment-container__title-block">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none" className="payment-container__icon">
            <rect x="0.43125" y="1.025" width="22.95" height="22.95" rx="4.275" stroke="#1570EF" strokeWidth="1.05"></rect>
            <path d="M12.675 7.83333C12.675 8.56971 11.0129 9.16667 8.9625 9.16667C6.91214 9.16667 5.25 8.56971 5.25 7.83333M12.675 7.83333C12.675 7.09695 11.0129 6.5 8.9625 6.5C6.91214 6.5 5.25 7.09695 5.25 7.83333M12.675 7.83333V8.83333M5.25 7.83333V15.8333C5.25 16.5697 6.91214 17.1667 8.9625 17.1667M8.9625 11.8333C8.84873 11.8333 8.73616 11.8315 8.625 11.8279C6.73281 11.7667 5.25 11.1955 5.25 10.5M8.9625 14.5C6.91214 14.5 5.25 13.903 5.25 13.1667M18.75 12.1667C18.75 12.903 17.0879 13.5 15.0375 13.5C12.9871 13.5 11.325 12.903 11.325 12.1667M18.75 12.1667C18.75 11.4303 17.0879 10.8333 15.0375 10.8333C12.9871 10.8333 11.325 11.4303 11.325 12.1667M18.75 12.1667V17.1667C18.75 17.903 17.0879 18.5 15.0375 18.5C12.9871 18.5 11.325 17.903 11.325 17.1667V12.1667M18.75 14.6667C18.75 15.403 17.0879 16 15.0375 16C12.9871 16 11.325 15.403 11.325 14.6667" stroke="#1570EF" strokeWidth="1.05" strokeLinecap="round" strokeLinejoin="round"></path>
          </svg>
          <p className="payment-container__title">Rent ASICs /</p>
          <p className="payment-container__subtitle">Payment</p>
        </div>
        <button className="ui-back payment-container__back" type="button" onClick={handleBack}>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M15.8333 9.99996H4.16663M4.16663 9.99996L9.99996 15.8333M4.16663 9.99996L9.99996 4.16663" stroke="#475467" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"></path>
          </svg>
          <p className="ui-back__button">Back</p>
        </button>

        <div className="payment-summary">
          <div className="payment-summary__title">Order Summary</div>
          <div className="payment-summary__details">
            <div className="payment-summary__row">
              <span>TH Power:</span>
              <span>{hashrate.toFixed(2)} TH/s</span>
            </div>
            <div className="payment-summary__row">
              <span>Contract Period:</span>
              <span>{contractPeriod} months</span>
            </div>
            <div className="payment-summary__row">
              <span>Prepaid Electricity:</span>
              <span>{prepaidMonths} months</span>
            </div>
            <div className="payment-summary__row payment-summary__row--total">
              <span>Total Amount:</span>
              <span>{formatCurrency(paymentAmount)}</span>
            </div>
          </div>
        </div>

        {step === 1 && (
          <div className="payment-methods">
            <h2 className="payment-methods__title">Select Payment Method</h2>
            <div className="payment-methods__grid">
              <button className="payment-method-card" onClick={() => selectMethod('crypto')}>
                <div className="payment-method-card__icon">₿</div>
                <div className="payment-method-card__title">Cryptocurrency</div>
                <div className="payment-method-card__desc">Pay with BTC, ETH, USDT, USDC</div>
              </button>
              <button className="payment-method-card" onClick={() => selectMethod('card')}>
                <div className="payment-method-card__icon">💳</div>
                <div className="payment-method-card__title">Credit/Debit Card</div>
                <div className="payment-method-card__desc">Visa, Mastercard, Amex</div>
              </button>
              <button className="payment-method-card" onClick={() => selectMethod('bank')}>
                <div className="payment-method-card__icon">🏦</div>
                <div className="payment-method-card__title">Bank Transfer</div>
                <div className="payment-method-card__desc">Wire transfer or ACH</div>
              </button>
              <button className="payment-method-card" onClick={() => selectMethod('mpesa')}>
                <div className="payment-method-card__icon">📱</div>
                <div className="payment-method-card__title">M-Pesa</div>
                <div className="payment-method-card__desc">Mobile money payment</div>
              </button>
            </div>
          </div>
        )}

        {step === 2 && selectedMethod === 'crypto' && (
          <div className="payment-form">
            <h2 className="payment-form__title">Pay with Cryptocurrency</h2>
            <div className="form-group">
              <label className="form-label">Select Cryptocurrency</label>
              <select className="form-select" value={selectedCoin} onChange={onCoinChange}>
                <option value="">Choose a cryptocurrency</option>
                <option value="btc">Bitcoin (BTC)</option>
                <option value="eth">Ethereum (ETH)</option>
                <option value="usdt">Tether (USDT)</option>
                <option value="usdc">USD Coin (USDC)</option>
                <option value="bnb">Binance Coin (BNB)</option>
                <option value="sol">Solana (SOL)</option>
              </select>
            </div>
            {selectedCoin && (
              <>
                <div className="form-group">
                  <label className="form-label">Select Network</label>
                  <select className="form-select" value={selectedNetwork} onChange={onNetworkChange}>
                    <option value="">Choose a network</option>
                    {selectedCoin === 'btc' && <option value="btc">Bitcoin Network</option>}
                    {selectedCoin === 'eth' && <option value="erc20">ERC-20</option>}
                    {selectedCoin === 'usdt' && (
                      <>
                        <option value="erc20">ERC-20</option>
                        <option value="trc20">TRC-20</option>
                      </>
                    )}
                    {selectedCoin === 'usdc' && (
                      <>
                        <option value="erc20">ERC-20</option>
                        <option value="trc20">TRC-20</option>
                      </>
                    )}
                    {selectedCoin === 'bnb' && <option value="bep20">BEP-20</option>}
                    {selectedCoin === 'sol' && <option value="sol">Solana Network</option>}
                  </select>
                </div>
                {selectedNetwork && (
                  <div className="form-group">
                    <button className="btn btn-primary btn-full" onClick={generateAddress}>
                      Generate Payment Address
                    </button>
                  </div>
                )}
              </>
            )}
          </div>
        )}

        {step === 3 && selectedMethod === 'crypto' && address && (
          <div className="payment-address">
            <h2 className="payment-address__title">Send Payment</h2>
            <div className="payment-address__info">
              <p>Send exactly <strong>{formatCurrency(paymentAmount)}</strong> worth of {selectedCoin.toUpperCase()} to:</p>
              <div className="payment-address__box">
                <code className="payment-address__code">{address}</code>
                <button className="btn btn-secondary" onClick={copyAddress}>Copy</button>
              </div>
              <p className="payment-address__warning">⚠️ Send only {selectedCoin.toUpperCase()} to this address. Sending other cryptocurrencies may result in permanent loss.</p>
            </div>
          </div>
        )}

        {step === 2 && selectedMethod === 'card' && (
          <div className="payment-form">
            <h2 className="payment-form__title">Pay with Card</h2>
            <div className="form-group">
              <label className="form-label">Card Number</label>
              <input
                type="text"
                className="form-input"
                placeholder="1234 5678 9012 3456"
                maxLength="19"
                value={cardNumber}
                onChange={formatCardNumber}
              />
            </div>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Expiry Date</label>
                <input
                  type="text"
                  className="form-input"
                  placeholder="MM/YY"
                  maxLength="5"
                  value={cardExpiry}
                  onChange={formatExpiry}
                />
              </div>
              <div className="form-group">
                <label className="form-label">CVV</label>
                <input
                  type="text"
                  className="form-input"
                  placeholder="123"
                  maxLength="4"
                  value={cardCvv}
                  onChange={(e) => setCardCvv(e.target.value)}
                />
              </div>
            </div>
            <div className="form-group">
              <label className="form-label">Amount</label>
              <input
                type="text"
                className="form-input"
                value={formatCurrency(paymentAmount)}
                disabled
              />
            </div>
            <button className="btn btn-primary btn-full btn-lg" onClick={submitCard}>
              Pay {formatCurrency(paymentAmount)}
            </button>
          </div>
        )}

        {step === 2 && selectedMethod === 'bank' && (
          <div className="payment-form">
            <h2 className="payment-form__title">Bank Transfer</h2>
            <div className="form-group">
              <label className="form-label">Amount (USD)</label>
              <input
                type="text"
                className="form-input"
                value={formatCurrency(paymentAmount)}
                disabled
              />
            </div>
            <div className="form-group">
              <label className="form-label">Transaction Reference</label>
              <input
                type="text"
                className="form-input"
                placeholder="Enter bank transaction reference"
                value={bankReference}
                onChange={(e) => setBankReference(e.target.value)}
              />
            </div>
            <button className="btn btn-primary btn-full btn-lg" onClick={submitBank}>
              Submit Payment Request
            </button>
          </div>
        )}

        {step === 2 && selectedMethod === 'mpesa' && (
          <div className="payment-form">
            <h2 className="payment-form__title">M-Pesa Payment</h2>
            <div className="form-group">
              <label className="form-label">Phone Number</label>
              <input
                type="tel"
                className="form-input"
                placeholder="254712345678"
                value={mpesaPhone}
                onChange={(e) => setMpesaPhone(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label className="form-label">Amount (KES)</label>
              <input
                type="text"
                className="form-input"
                value={formatCurrency(paymentAmount)}
                disabled
              />
            </div>
            {!mpesaPending ? (
              <button className="btn btn-primary btn-full btn-lg" onClick={submitMpesa}>
                Pay via M-Pesa
              </button>
            ) : (
              <div className="mpesa-pending">
                <p>Waiting for M-Pesa confirmation...</p>
                <div className="mpesa-actions">
                  <button className="btn btn-secondary" onClick={cancelMpesa}>Cancel</button>
                  <button className="btn btn-primary" onClick={confirmMpesa}>Confirm Payment</button>
                </div>
              </div>
            )}
          </div>
        )}

        {step === 3 && selectedMethod !== 'crypto' && (
          <div className="payment-success">
            <div className="payment-success__icon">✓</div>
            <h2 className="payment-success__title">Payment Submitted</h2>
            <p className="payment-success__message">Your payment request has been submitted. You will receive a confirmation email shortly.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Payment;

